export const TERMS_OF_USE_STATUS_QUERY_KEY = ['termsOfUseStatus'] as const;
export const ACCEPT_TERMS_OF_USE_QUERY_KEY = ['acceptTermsOfUse'] as const;

export const DEFAULT_CACHE_THRESHOLD = 5;
